var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invoice-record" },
    [
      _c(
        "el-card",
        {
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: "20px" },
          },
        },
        [
          _c("div", { staticClass: "mb15" }, [
            _c("span", { staticClass: "page-title" }, [_vm._v("发票记录管理")]),
          ]),
          _c(
            "el-row",
            { staticClass: "mb15", attrs: { gutter: 24, type: "flex" } },
            [
              _c("el-col", { attrs: { span: 8 } }, [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("div", { staticClass: "laber-width" }, [
                      _vm._v("发票抬头："),
                    ]),
                    _c("el-input", {
                      attrs: {
                        placeholder: "发票抬头",
                        size: "small",
                        clearable: "",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleQuery($event)
                        },
                      },
                      model: {
                        value: _vm.queryParams.invoiceTitle,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "invoiceTitle", $$v)
                        },
                        expression: "queryParams.invoiceTitle",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("el-col", { attrs: { span: 8 } }, [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("div", { staticClass: "laber-width" }, [
                      _vm._v("开票编码："),
                    ]),
                    _c("el-input", {
                      attrs: {
                        placeholder: "开票编码/申请单号",
                        size: "small",
                        clearable: "",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleQuery($event)
                        },
                      },
                      model: {
                        value: _vm.queryParams.invoiceCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "invoiceCode", $$v)
                        },
                        expression: "queryParams.invoiceCode",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("el-col", { attrs: { span: 8 } }, [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("div", { staticClass: "laber-width" }, [
                      _vm._v("订单号："),
                    ]),
                    _c("el-input", {
                      attrs: {
                        placeholder: "开票订单号",
                        size: "small",
                        clearable: "",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleQuery($event)
                        },
                      },
                      model: {
                        value: _vm.queryParams.orderNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "orderNo", $$v)
                        },
                        expression: "queryParams.orderNo",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "mb15", attrs: { gutter: 24, type: "flex" } },
            [
              _c("el-col", { attrs: { span: 8 } }, [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("div", { staticClass: "laber-width" }, [
                      _vm._v("开票类型："),
                    ]),
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "开票类型",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.queryParams.invoiceType,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "invoiceType", $$v)
                          },
                          expression: "queryParams.invoiceType",
                        },
                      },
                      [
                        _c("el-option", { attrs: { label: "个人", value: 0 } }),
                        _c("el-option", { attrs: { label: "企业", value: 1 } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("el-col", { attrs: { span: 8 } }, [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("div", { staticClass: "laber-width" }, [
                      _vm._v("发票类型："),
                    ]),
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "发票类型",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.queryParams.category,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "category", $$v)
                          },
                          expression: "queryParams.category",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "增值税普通发票", value: 1 },
                        }),
                        _c("el-option", {
                          attrs: { label: "增值税专用发票", value: 2 },
                        }),
                        _c("el-option", {
                          attrs: { label: "电子发票", value: 3 },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("el-col", { attrs: { span: 8 } }, [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("div", { staticClass: "laber-width" }, [
                      _vm._v("发票状态："),
                    ]),
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "发票状态",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.queryParams.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "status", $$v)
                          },
                          expression: "queryParams.status",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "申请中", value: 0 },
                        }),
                        _c("el-option", {
                          attrs: { label: "已开票", value: 1 },
                        }),
                        _c("el-option", {
                          attrs: { label: "已拒绝", value: 2 },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "mb15", attrs: { gutter: 24, type: "flex" } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("div", { staticClass: "laber-width" }, [
                      _vm._v("搜索："),
                    ]),
                    _c("el-input", {
                      attrs: {
                        placeholder: "订单号 / 发票抬头",
                        size: "small",
                        clearable: "",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleQuery($event)
                        },
                      },
                      model: {
                        value: _vm.queryParams.keyword,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "keyword", $$v)
                        },
                        expression: "queryParams.keyword",
                      },
                    }),
                    _c(
                      "el-button",
                      {
                        staticClass: "ml20",
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.handleQuery },
                      },
                      [_vm._v("搜索")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.resetQuery },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.list, border: "", stripe: "", size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "编号",
                  align: "center",
                  prop: "id",
                  width: "80",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "开票编码",
                  align: "center",
                  prop: "invoiceCode",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "订单号",
                  align: "center",
                  prop: "orderNo",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "发票抬头",
                  align: "center",
                  prop: "invoiceTitle",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "开票金额",
                  align: "center",
                  prop: "invoiceAmount",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " ¥" +
                            _vm._s(
                              Number(scope.row.invoiceAmount || 0).toFixed(2)
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "开票类型",
                  align: "center",
                  prop: "invoiceType",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.invoiceType === 0
                          ? _c(
                              "el-tag",
                              { attrs: { type: "info", size: "mini" } },
                              [_vm._v("个人")]
                            )
                          : scope.row.invoiceType === 1
                          ? _c(
                              "el-tag",
                              { attrs: { type: "success", size: "mini" } },
                              [_vm._v("企业")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "发票类型",
                  align: "center",
                  prop: "category",
                  width: "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.category === 1
                          ? _c("el-tag", { attrs: { size: "mini" } }, [
                              _vm._v("增值税普通发票"),
                            ])
                          : scope.row.category === 2
                          ? _c(
                              "el-tag",
                              { attrs: { type: "warning", size: "mini" } },
                              [_vm._v("增值税专用发票")]
                            )
                          : scope.row.category === 3
                          ? _c(
                              "el-tag",
                              { attrs: { type: "primary", size: "mini" } },
                              [_vm._v("电子发票")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "发票状态",
                  align: "center",
                  prop: "status",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === 0
                          ? _c(
                              "el-tag",
                              { attrs: { type: "info", size: "mini" } },
                              [_vm._v("申请中")]
                            )
                          : scope.row.status === 1
                          ? _c(
                              "el-tag",
                              { attrs: { type: "success", size: "mini" } },
                              [_vm._v("已开票")]
                            )
                          : scope.row.status === 2
                          ? _c(
                              "el-tag",
                              { attrs: { type: "warning", size: "mini" } },
                              [_vm._v("已拒绝")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "申请时间",
                  align: "center",
                  prop: "applyTime",
                  width: "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "开票时间",
                  align: "center",
                  prop: "invoiceTime",
                  width: "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  align: "center",
                  width: "200",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDetail(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                        scope.row.status === 0
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleUploadInvoice(scope.row.id)
                                  },
                                },
                              },
                              [_vm._v("去开票")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "mt10 text-right" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryParams.pageNum,
                  "page-size": _vm.queryParams.pageSize,
                  "page-sizes": [10, 20, 50, 100],
                  total: _vm.total,
                  layout: "total, sizes, prev, pager, next",
                },
                on: {
                  "current-change": _vm.pageChange,
                  "size-change": _vm.sizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("InvoiceRecordForm", { ref: "formRef", on: { success: _vm.getList } }),
      _c("InvoiceRecordDetail", { ref: "detailRef" }),
      _c("InvoiceUploadForm", {
        ref: "uploadFormRef",
        on: { success: _vm.getList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }